import {EVENT_ID, dispatch} from '../../../../containers/event_manager';

export const createToast = props => {
	dispatch(EVENT_ID.SHOW_TOAST, props);
};

export const showChangesSavedToast = formatMessage => {
	createToast({duration: 2000, message: formatMessage({id: 'common.changes_saved'})});
};
